import type { RouteLocationRaw } from 'vue-router'
import { buildRouteWithListScope } from '@/shared/scope/listScope'
import { isAccountContextPath } from '@/shared/constants/accountContext'

function normalizePath(path: string): string {
  return path.split('?')[0]?.replace(/\/$/, '') || '/'
}

export function parseAccountQueryParam(value: unknown): string | number | undefined {
  if (typeof value === 'string' && value.trim().length > 0) return value
  if (Array.isArray(value) && typeof value[0] === 'string' && value[0].trim().length > 0) {
    return value[0]
  }
  return undefined
}

/** Append account scope to navigation targets. Prefer buildRouteWithListScopeFromRoute. */
export function buildRouteWithAccountContext(
  to: RouteLocationRaw,
  scope: { accountId?: string | number; resellerId?: string | number }
): RouteLocationRaw {
  if (typeof to === 'string' && !isAccountContextPath(normalizePath(to))) return to
  return buildRouteWithListScope(to, scope)
}
